export type DischargeStatus =
  | "clear"
  | "discharging"
  | "recently-discharged"
  | "offline"
  | "unknown";

export type CsoMonitor = {
  id: string;
  name: string;
  waterCompany: string;
  status: DischargeStatus;
  lastDischargeStart: string | null;
  lastDischargeEnd: string | null;
  distanceKm: number | null;
};

export type DischargeEvent = {
  date: string;
  durationHours: number;
  status: "started" | "stopped";
};

export type WaterQualityData = {
  overallStatus: DischargeStatus;
  alertMessage: string | null;
  monitors: CsoMonitor[];
  recentEvents: DischargeEvent[];
  lastChecked: string;
  dataSource: string;
};

export function statusColor(status: DischargeStatus): {
  bg: string;
  text: string;
  border: string;
  dot: string;
} {
  switch (status) {
    case "clear":
      return { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200", dot: "bg-emerald-400" };
    case "discharging":
      return { bg: "bg-red-50", text: "text-red-800", border: "border-red-200", dot: "bg-red-500" };
    case "recently-discharged":
      return { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", dot: "bg-amber-400" };
    case "offline":
      return { bg: "bg-slate-50", text: "text-slate-600", border: "border-slate-200", dot: "bg-slate-400" };
    case "unknown":
      return { bg: "bg-slate-50", text: "text-slate-600", border: "border-slate-200", dot: "bg-slate-300" };
  }
}

export function statusLabel(status: DischargeStatus): string {
  switch (status) {
    case "clear": return "Clear";
    case "discharging": return "Elevated levels";
    case "recently-discharged": return "Recent concern";
    case "offline": return "No recent data";
    case "unknown": return "No data";
  }
}
